var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNinjaTurtle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_398",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29256",
    "data-name": "Group 29256",
    transform: "translate(64 10935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -64, -10935)",
    filter: "url(#Ellipse_398)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_398-2",
    "data-name": "Ellipse 398",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-ninja-turtle",
    transform: "translate(-46.362 -10921.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50200",
    "data-name": "Path 50200",
    d: "M32.625,22.452c0-2.034-1.38-3.777-3.486-5.156A10.182,10.182,0,0,0,18.826,8,10.182,10.182,0,0,0,8.513,17.3C6.335,18.6,5.1,20.492,5.1,22.452c0,2.905,2.76,5.374,6.754,6.682A8.2,8.2,0,0,0,18.9,32.693a8.762,8.762,0,0,0,7.045-3.559C29.865,27.827,32.625,25.357,32.625,22.452Z",
    transform: "translate(0 -0.027)",
    fill: "#8bc34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50201",
    "data-name": "Path 50201",
    d: "M38.781,13.928a4.451,4.451,0,0,1,.145-3.559A15.476,15.476,0,0,0,40.161,7.9a4.4,4.4,0,0,1,1.307,4.067,4.171,4.171,0,0,1-2.905,3.123C38.345,15.308,38.926,15.163,38.781,13.928Z",
    transform: "translate(-9.134)",
    fill: "#d32f2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50202",
    "data-name": "Path 50202",
    d: "M37.3,13.955a4.6,4.6,0,0,1-1.307-3.341A21.439,21.439,0,0,0,36.21,8a4.508,4.508,0,0,1,2.905,3.2,4.094,4.094,0,0,1-1.452,3.994C37.444,15.408,37.88,14.972,37.3,13.955Z",
    transform: "translate(-8.451 -0.027)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50203",
    "data-name": "Path 50203",
    d: "M30.634,15.843A8.473,8.473,0,0,0,25.768,14.1c-2.251,0-3.922,1.307-5.737,1.307S16.545,14.1,14.293,14.1s-2.978.218-3.777,1.089c-.872.872-1.017,3.994-1.017,3.994a9.261,9.261,0,0,0,4.939,1.6,6.884,6.884,0,0,1,5.52-2.687,7.577,7.577,0,0,1,5.81,2.76,8.592,8.592,0,0,0,5.011-1.67C31.07,18.385,31.215,16.351,30.634,15.843Z",
    transform: "translate(-1.204 -1.697)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50204",
    "data-name": "Path 50204",
    d: "M15.268,17.1a7.509,7.509,0,0,1,4.067,1.6c-2.251.508-2.687,1.307-3.7,1.38A7.689,7.689,0,0,1,12,19.351S13.162,17.1,15.268,17.1Zm10.749,0a7.509,7.509,0,0,0-4.067,1.6c2.324.508,2.905,1.307,3.849,1.38a7.289,7.289,0,0,0,3.559-.726S28.123,17.1,26.017,17.1Z",
    transform: "translate(-1.889 -2.518)",
    fill: "#efebe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50205",
    "data-name": "Path 50205",
    d: "M26.468,18.9a.993.993,0,0,0-1.017,1.017v.145a5.006,5.006,0,0,0,1.525.581h.218a1.008,1.008,0,0,0,.363-.726A1.055,1.055,0,0,0,26.468,18.9Zm-9.151,0A.993.993,0,0,0,16.3,19.917a.894.894,0,0,0,.363.726h.218a5.006,5.006,0,0,0,1.525-.581v-.145A1.1,1.1,0,0,0,17.317,18.9Z",
    transform: "translate(-3.066 -3.011)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28953",
    "data-name": "Group 28953",
    transform: "translate(12.145 15.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50206",
    "data-name": "Path 50206",
    d: "M15.381,27.788a15.61,15.61,0,0,0,11.184,0c2.179-.872,2.179,1.452.363,1.816C18.141,30.911,15.381,27.788,15.381,27.788ZM21.482,19C16.4,19,14.8,23.866,14.8,23.866a8.155,8.155,0,0,1,6.682-3.413,8,8,0,0,1,6.682,3.341S26.565,19,21.482,19Z",
    transform: "translate(-14.8 -19)",
    fill: "#33691e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinjaTurtle);
export default __webpack_public_path__ + "static/media/ninjaTurtle.03f9c242fbf2a2198ec6de016b3672e8.svg";
export { ForwardRef as ReactComponent };